export default __webpack_public_path__ + "static/media/Udbhav.81772138.webp";